// Pixelate a canvas in place using the same mosaic language as faceMask.ts's
// auto-mask: grid the image, fill each block with its top-left pixel.
// Split into its own module so both the auto mask and the manual blur editor
// share one visual treatment.
//
// Performance: reads the whole canvas ONCE into an ImageData buffer, rewrites
// the block colours in the array, and puts it back in a single call. The
// previous per-block getImageData(x, y, 1, 1) loop cost ~1000 canvas readbacks
// on a phone photo and froze the editor for seconds on open.
const pixelateCanvas = (canvas: HTMLCanvasElement): void => {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const w = canvas.width;
  const h = canvas.height;
  const block = Math.max(14, Math.round(Math.min(w, h) / 24));

  const img = ctx.getImageData(0, 0, w, h);
  const d = img.data;

  for (let by = 0; by < h; by += block) {
    for (let bx = 0; bx < w; bx += block) {
      const bw = Math.min(block, w - bx);
      const bh = Math.min(block, h - by);
      // Top-left pixel of the block is the fill colour (matches pixelateRegion).
      const si = (by * w + bx) * 4;
      const r = d[si];
      const g = d[si + 1];
      const b = d[si + 2];
      for (let y = by; y < by + bh; y++) {
        let di = (y * w + bx) * 4;
        for (let x = 0; x < bw; x++) {
          d[di] = r;
          d[di + 1] = g;
          d[di + 2] = b;
          di += 4;
        }
      }
    }
  }
  ctx.putImageData(img, 0, 0);
};

export default pixelateCanvas;
